module.exports = __webpack_public_path__ + "img/asus-watch-2.a5fc9ff6.jpg";